import React from 'react';
import { Card, CardContent, Typography, Divider, Box } from '@material-ui/core';
import UserListItem from '../../organisim/user-list-item';
import Chip from '@material-ui/core/Chip';
import { monthFormat } from '../../../lib/utils/date-format';
import styled from 'styled-components';
import { Flex } from '@rebass/grid';
import { colors } from '../../../config/theme';
import DashboardMemberProfileDrawer from './dashboard-member-profile-drawer';

const ListItemContainer = styled.div`
  border-bottom: 1px solid ${colors.border};
`;

const TableContainer = styled.div`
  height: 384px;
`;

export const NewMembers = ({ newMembers, signupCount }) => {
  const [isDrawerOpen, setisDrawerOpen] = React.useState(false);
  const [activeMember, setActiveMember] = React.useState({});
  const handleProfileClick = (user) => {
    setActiveMember(user);
    setisDrawerOpen(true);
  };

  return (
    <Card>
      <TableContainer>
        <CardContent>
          <Box>
            <Flex mb="30px" justifyContent="space-between">
              <Typography variant="h6">{signupCount} New sign ups</Typography>
              {/* {signupCount > 3 && (
                <Button variant="outlined" color="primary">
                  <Typography variant="body1">View All</Typography>
                </Button>
              )} */}
            </Flex>
            <Flex justifyContent="space-between" p="16px">
              <Typography variant="body1">Name</Typography>
              <Typography variant="body1">Sign up date</Typography>
            </Flex>
          </Box>
          <Divider />
          {newMembers.map((user, i) => {
            if (i < 3) {
              return (
                <ListItemContainer key={`${i}-${user.name}`}>
                  <div onClick={() => handleProfileClick(user)}>
                    <UserListItem user={user}>
                      <Chip label={monthFormat(user.created_at)} />
                    </UserListItem>
                  </div>
                </ListItemContainer>
              );
            } else return null;
          })}
        </CardContent>
      </TableContainer>
      <DashboardMemberProfileDrawer
        open={isDrawerOpen}
        member={activeMember}
        onClose={() => setisDrawerOpen(false)}
      />
    </Card>
  );
};
